import Header from "../../../common/header/Header";

const HeaderPPHI = () => {
    return (
        <div className="header-wrapper">
            <Header />
            <div className="header_bottom">
              <div className="header-bottom-contain">
                <div className="header_bottom_text">
                  Aditya Birla Sun Life Insurance Company Limited
                </div>
              </div>
            </div>
          </div>
    );
}

export default HeaderPPHI;
